import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseCompanyUsersProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    companyId?: string;
    branchId?: string;
  };
  mapper?: (data: any) => T,
};

export const useCompanyUsers = <T,>({
  filters: { search = '', page, companyId, branchId } = {},
  mapper = Mapper.default<T>(),
}: UseCompanyUsersProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['companyUsers', search, page, companyId, branchId],
    queryFn: () => {
      return privateAxios.get('/users', {
        params: {
          search,
          page,
          'q[company_id_eq]': companyId,
          'q[company_branch_id_eq]': branchId
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
